import { ApiParameter, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

const customFormsBaseUrl = "api/v1/customforms";
const customformUrl = "submit";

export interface CustomFormApiParameter extends ApiParameter {
    customformModel: CustomFormModel;
}
export interface KeyValue {
  [key: string]: string;
}

export interface CustomFormModel extends BaseModel {
    recepientEmails:string;
    formType:string;
    emailTemplate:string,
    values:KeyValue;
}


export async function submit(parameter: CustomFormApiParameter): Promise<ServiceResult<CustomFormModel>> {
     try {
            const customformModel = await post<CustomFormModel>(`${customFormsBaseUrl}/${customformUrl}`, parameter.customformModel);
            return {
                successful: true,
                result: customformModel
            };
        } catch (error) {
            if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
                return {
                    successful: false,
                    errorMessage: error.errorJson.message,
                };
            }
            throw error;
        }
}

